/* ==============================
   CWC Portfolio Case Studies
   Filter Tabs Behavior
   ----------------------------------------
   - Click a tab → filter cards whose
     data-tag matches the tab's data-filter
   - "all" filter shows everything
   - Per-section scope (multiple sections
     on same page don't interfere)
   - Re-binds on shopify:section:load
   ============================== */

(function () {
  "use strict";

  function initSection(root) {
    if (!root) return;
    var tabs = root.querySelectorAll(".cwc_portfolio_case-studies__tab");
    var cards = root.querySelectorAll("[data-case-card]");
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      if (tab.dataset.cwcBound === "true") return;
      tab.dataset.cwcBound = "true";

      tab.addEventListener("click", function () {
        var filter = tab.dataset.filter;
        if (!filter) return;

        // Update tab visual / a11y state
        tabs.forEach(function (other) {
          var isActive = other === tab;
          other.classList.toggle("is-active", isActive);
          other.setAttribute("aria-selected", isActive ? "true" : "false");
        });

        // Show/hide cards
        cards.forEach(function (card) {
          var tag = card.dataset.tag || "";
          var show = filter === "all" || tag === filter;
          if (show) {
            card.hidden = false;
            card.removeAttribute("hidden");
          } else {
            card.hidden = true;
            card.setAttribute("hidden", "");
          }
        });
      });
    });
  }

  function initAll(scope) {
    var sections = (scope || document).querySelectorAll(
      ".cwc_portfolio_case-studies",
    );
    sections.forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e && e.target) initAll(e.target);
  });
})();
